"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
        newWindow.opener = null;
    }
};
exports.default = openInNewTab;
